import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AlertComponent } from './shared/alert/alert.component';
import { LoaderComponent } from './shared/loader/loader.component';
import { CredentialsService } from 'src/services/core/credentials/credentials.service';
import { HeaderComponent } from './shared/header/header.component';
import { NgIf } from '@angular/common';
import { Logger } from 'src/services/core/logger/logger.service';
import { environment } from 'src/environments/environment';
import { PersistenceService } from 'src/services/core/persistence/persistence.service';
import { NotifsService } from 'src/services/data/notifications/notifs.service';
import { Response } from 'src/services/classes/models/response.interface';
import { NotificationsService } from 'src/services/classes/notifications/notifications.service';

const log = new Logger('App');
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    NgIf,
    LoaderComponent,
    AlertComponent,
  ],
})
export class AppComponent implements OnInit {
  constructor(
    private credentialService: CredentialsService,
    private persistenceService: PersistenceService,
    private notifsService: NotifsService,
    private notifyService: NotificationsService
  ) {}

  isAuthenticated = () => this.credentialService.isAuthenticated();

  ngOnInit(): void {
    if (environment.production) {
      Logger.enableProductionMode();
    }

    if (this.credentialService.isAuthenticated()) {
      this.setupAutoRefresh();
    }
  }

  getAllNotifications() {
    const notifications$ = this.notifsService.getAllNotifications();
    notifications$.subscribe({
      next: (res: Response) => {
        if (res.status.toLowerCase() === 'success') {
          if (res.data) {
            this.persistenceService.set('notifications', res.data);
          }
        } else {
          res?.message
            ? this.notifyService.publishMessages(res.message, 'danger', 1)
            : this.notifyService.publishMessages(
                'An error occurred',
                'danger',
                1
              );
        }
      },
      error: (error) => log.debug('error: ', error),
    });
  }

  setupAutoRefresh() {
    // Refetch notifications every 3 minutes
    setInterval(() => this.getAllNotifications(), 180000);
  }
}
